import React from 'react';
import {Link} from "react-router-dom";
import ScrollAnimation from "react-animate-on-scroll";

const ServiceList = [
    {
        image: '/images/service/service-software-development.jpg',
        title: 'Software Development',
        description: 'First think like a customer, then develop. That is what we understand from how to develop high quality software. Get in touch to see what we can do for you.'
    },
    {
        image: '/images/service/service-test-automation.jpeg',
        title: 'Test Automation',
        description: 'Let us automate your regression, smoke tests to unblock the manual testing bottleneck on the way to releases. We have experts to make this happen in short time.'
    },
    {
        image: '/images/service/service-product-excellence.jpeg',
        title: 'Product Excellence Test',
        description: 'There are many different ways to test a product and understand the quality of it. Our holistic testing approach puts the users first and choose the right test to do.'
    },
    {
        image: '/images/service/service-quality-assurance.jpeg',
        title: 'Quality Assurance Consultancy',
        description: 'Do you want to develop a QA strategy? You want to understand where to start or who to hire? You are on the right spot because our experts worked on fastgrowing startups and established their QA strategy.'
    }
]
const ServiceTwo = ({textAlign, cardStyle}) => {
    return (
        <div className="row row--15 service-wrapper">
              {ServiceList.map( (val , i) => (
                <div className="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-12" key={i}>
                    <ScrollAnimation 
                    animateIn="fadeInUp"
                    animateOut="fadeInOut"
                    animateOnce={true}>
                        <div className={`card-box ${cardStyle} ${textAlign}`}>
                            <div className="inner">
                                <div className="image">
                                    <Link to="#service">
                                        <img src={`${val.image}`} alt="card Images" />
                                    </Link>
                                </div>
                                <div className="content">
                                    <h4 className="title mb--20"><Link to="#service" dangerouslySetInnerHTML={{__html: val.title}}></Link></h4>
                                    <p className="description b1 color-gray mb--0" dangerouslySetInnerHTML={{__html: val.description}}></p>
                                    <Link className="btn-default btn-small btn-border" to="#service">Read More</Link>
                                </div>
                            </div>
                        </div>
                    </ScrollAnimation>
                </div>
            ))}
        </div>
    )
}
export default ServiceTwo;